var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tinymce-container",class:{fullscreen:_vm.fullscreen},style:({width:_vm.containerWidth})},[_c('editorImage',{staticClass:"editor-upload-btn",attrs:{"color":"#1890ff"},on:{"successCBK":_vm.imageSuccessCBK}}),_c('textarea',{staticClass:"tinymce-textarea",attrs:{"id":_vm.tinymceId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }